import { BatteryIcon } from '@jouzen/ecom-components/icons/BatteryIcon';
import { HeartIcon } from '@jouzen/ecom-components/icons/HeartIcon';
import { MeditationIcon } from '@jouzen/ecom-components/icons/MeditationIcon';
import { MoonIcon } from '@jouzen/ecom-components/icons/MoonIcon';
import { ThumbsUpIcon } from '@jouzen/ecom-components/icons/ThumbsUpIcon';
import { BREAKPOINTS } from '@jouzen/ecom-components/v3/consts/breakpoints';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import React from 'react';

import Image from '@/app/components/Image';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import RichText from '@/app/components/RichText';

export default function PerimenopauseLearn() {
  return (
    <section data-cy="perimenopause-learn">
      <LayoutGrid>
        <GridItem
          colStart={{ sm: 'main' }}
          colEnd={{ sm: 'main', md: 10 }}
          className="order-2 flex flex-col justify-center max-md:mt-125 md:order-1 lg:pr-3"
        >
          <Typography
            variant={'h4'}
            className="mb-6 leading-tight tracking-tighter"
          >
            <RichText messageKey="perimenopause_learn_why_feel_title" />
          </Typography>
          <Typography variant={'h6'} className="mb-12 md:text-balance">
            <RichText messageKey="perimenopause_learn_why_feel_copy" />
          </Typography>
          <ul className="space-y-6">
            <li className="flex flex-row items-center gap-3">
              <MoonIcon />
              <RichText messageKey="daily_sleep_activity_readiness_scores" />
            </li>
            <li className="flex flex-row items-center gap-3">
              <HeartIcon />
              <RichText messageKey="heart_health" />
            </li>
            <li className="flex flex-row items-center gap-3">
              <MeditationIcon />
              <RichText messageKey="stress_and_resilience" />
            </li>
            <li className="flex flex-row items-center gap-3">
              <BatteryIcon />
              <RichText messageKey="perimenopause_battery" />
            </li>
            <li className="flex flex-row items-center gap-3">
              <ThumbsUpIcon />
              <RichText messageKey="hsa_fsa_eligible_plain" />
            </li>
          </ul>
        </GridItem>
        <GridItem
          colStart={{ sm: 'full', md: 13 }}
          colEnd={{ sm: 'full' }}
          className="relative order-1 md:order-2"
        >
          <div className="relative w-full overflow-hidden max-md:aspect-375/500 max-md:max-h-150 md:h-192.5 md:rounded-l-3xl">
            <ArtDirectionImage
              localizedAlt="perimenopause_lifestyle_alt_two"
              width={375}
              height={500}
              priority
              className="h-full w-full object-cover"
              srcSet={[
                {
                  src: 'perimenopause-lifestyle-two.jpg?fit=crop&crop=focalpoint&fp-x=0.3&fp-y=0.45&fp-z=1.15',
                  media: `(max-width: ${BREAKPOINTS.medium}px)`,
                },
                {
                  src: 'perimenopause-lifestyle-two.jpg?fit=crop&crop=focalpoint&fp-x=0.4&fp-y=0&fp-z=1.15&flip=h',
                  media: `(min-width: ${BREAKPOINTS.medium}px)`,
                },
              ]}
            />
          </div>
          <Image
            className="absolute top-3/4 left-1/2 block -translate-x-1/2 object-cover md:hidden lg:top-1/2 lg:left-0 lg:block lg:-translate-y-1/2"
            localizedAlt="perimenopause_ui_alt_advisor"
            localizedSrc="perimenopause_health_app_src"
            width={290}
            height={600}
            priority
          />
        </GridItem>
      </LayoutGrid>
    </section>
  );
}
